import * as React from 'react';
import styled from 'styled-components';

export interface IProps {
  // eslint-disable-next-line
  children: JSX.Element;
  className?: string;
  style?: React.CSSProperties;
}

const StyledITag = styled.i`
  display: flex;
  align-items: center;
`;

export const Icon: React.FC<IProps> = ({ children, className, style }) => {
  return (
    <StyledITag className={`icon ${className ? className : ''}`} style={style}>
      {children}
    </StyledITag>
  );
};
